
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/jet-card",
      function () {
        return require("private-next-pages/dashboard/jet-card/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/jet-card"])
      });
    }
  